export default function setupMap(mapEl) {
  const BTN_ZOOM_IN = document.querySelector(".map__nav-btn--zoomin");
  const BTN_ZOOM_OUT = document.querySelector(".map__nav-btn--zoomout");
  const MAX_ZOOM = 2;
  const MIN_ZOOM = 1;
  const SVG_WIDTH = mapEl.viewBox.baseVal.width;
  const SVG_HEIGHT = mapEl.viewBox.baseVal.height;
  const container = document.querySelector(".wrapper");

  const clamp = (num, min, max) => Math.max(min, Math.min(num, max));

  /**
   * Debounce functions for better performance
   * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Function} fn The function to debounce
   */
  const debounce = function (fn) {
    // Setup a timer
    let timeout;

    // Return a function to run debounced
    return function () {
      // Setup the arguments
      const context = this;
      const args = arguments;

      // If there's a timer, cancel it
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }

      // Setup the new requestAnimationFrame()
      timeout = window.requestAnimationFrame(function () {
        fn.apply(context, args);
      });
    };
  };

  const disableButton = (button) => (button.disabled = true);
  const enableButton = (button) => (button.disabled = false);

  const setScaleButtonsState = (scale) => {
    if (scale <= MIN_ZOOM) {
      disableButton(BTN_ZOOM_OUT);
    } else {
      enableButton(BTN_ZOOM_OUT);
    }
    if (scale >= MAX_ZOOM) {
      disableButton(BTN_ZOOM_IN);
    } else {
      enableButton(BTN_ZOOM_IN);
    }
  };

  // Create an SVG point that contains x & y values
  const point = mapEl.createSVGPoint();
  // This function returns an object with X & Y values from the pointer event
  function getPointFromEvent(event) {
    // If even is triggered by a touch event, we get the position of the first finger
    if (event.targetTouches) {
      point.x = event.targetTouches[0].clientX;
      point.y = event.targetTouches[0].clientY;
    } else {
      point.x = event.clientX;
      point.y = event.clientY;
    }

    // We get the current transformation matrix of the SVG and we inverse it
    const invertedSVGMatrix = mapEl.getScreenCTM().inverse();

    return point.matrixTransform(invertedSVGMatrix);
  }

  // This variable will be used later for move events to check if pointer is down or not
  let isPointerDown = false;

  // This variable will contain the original coordinates when the user start pressing the mouse or touching the screen
  let pointerOrigin;

  // Function called by the event listeners when user start pressing/touching
  function onPointerDown(event) {
    isPointerDown = true; // We set the pointer as down

    // We get the pointer position on click/touchdown so we can get the value once the user starts to drag
    pointerOrigin = getPointFromEvent(event);
  }

  // We save the original values from the viewBox
  const viewBox = mapEl.viewBox.baseVal;

  const adjustPosition = debounce((x, y) => {
    const containerWidth = container.getBoundingClientRect().width;
    const svgOverflow = mapEl.width.baseVal.value - containerWidth;
    // relative coefficient to calculate viewBox units against pixels
    const VB_COEF = viewBox.width / mapEl.getBoundingClientRect().width;
    const limitX = SVG_WIDTH - viewBox.width + svgOverflow * VB_COEF;
    const limitY = SVG_HEIGHT - viewBox.height;

    viewBox.x = clamp(x, 0, limitX);
    viewBox.y = clamp(y, 0, limitY);
  });

  // Function called by the event listeners when user start moving/dragging
  function onPointerMove(event) {
    // Only run this function if the pointer is down
    if (!isPointerDown) {
      return;
    }
    if (event.touches && event.touches.length > 1) {
      return;
    }

    // Get the pointer position as an SVG Point
    const pointerPosition = getPointFromEvent(event);

    // Update the viewBox variable with the distance from origin and current position
    // We don't need to take care of a ratio because this is handled in the getPointFromEvent function
    adjustPosition(
      viewBox.x - (pointerPosition.x - pointerOrigin.x),
      viewBox.y - (pointerPosition.y - pointerOrigin.y)
    );
  }
  let currentScale = 1;
  const zoom = (dScale) => {
    if (currentScale <= 0.2 && dScale <= -0.2) dScale = 0;
    const newScale = clamp(
      parseFloat((currentScale + dScale).toFixed(1)),
      MIN_ZOOM,
      MAX_ZOOM
    );
    currentScale = newScale;
    setScaleButtonsState(newScale);
    viewBox.width = SVG_WIDTH / newScale;
    viewBox.height = SVG_HEIGHT / newScale;
    // clamp position within limits
    adjustPosition(
      (SVG_WIDTH - viewBox.width) / 2,
      (SVG_HEIGHT - viewBox.height) / 2
    );
  };

  function onPointerUp() {
    // The pointer is no longer considered as down
    isPointerDown = false;
  }

  // If browser supports pointer events
  if (window.PointerEvent) {
    mapEl.addEventListener("pointerdown", onPointerDown); // Pointer is pressed
    mapEl.addEventListener("pointerup", onPointerUp); // Releasing the pointer
    mapEl.addEventListener("pointerleave", onPointerUp); // Pointer gets out of the SVG area
    mapEl.addEventListener("pointermove", onPointerMove); // Pointer is moving
  } else {
    // Add all mouse events listeners fallback
    mapEl.addEventListener("mousedown", onPointerDown); // Pressing the mouse
    mapEl.addEventListener("mouseup", onPointerUp); // Releasing the mouse
    mapEl.addEventListener("mouseleave", onPointerUp); // Mouse gets out of the SVG area
    mapEl.addEventListener("mousemove", onPointerMove); // Mouse is moving
  }
  // Add all touch events listeners fallback
  mapEl.addEventListener("touchstart", onPointerDown); // Finger is touching the screen
  mapEl.addEventListener("touchend", onPointerUp); // Finger is no longer touching the screen
  mapEl.addEventListener("touchmove", onPointerMove); // Finger is moving
  BTN_ZOOM_IN.addEventListener("click", () => zoom(0.2));
  BTN_ZOOM_OUT.addEventListener("click", () => zoom(-0.2));
}
